__turbopack_context__.v({
  "PaymentTab": "Top-module__qZlxYG__PaymentTab",
  "Top": "Top-module__qZlxYG__Top",
  "active": "Top-module__qZlxYG__active",
  "addToCart": "Top-module__qZlxYG__addToCart",
  "attribute": "Top-module__qZlxYG__attribute",
  "borderContents": "Top-module__qZlxYG__borderContents",
  "bottom": "Top-module__qZlxYG__bottom",
  "brand": "Top-module__qZlxYG__brand",
  "btn": "Top-module__qZlxYG__btn",
  "button": "Top-module__qZlxYG__button",
  "buttons": "Top-module__qZlxYG__buttons",
  "buyNow": "Top-module__qZlxYG__buyNow",
  "changer": "Top-module__qZlxYG__changer",
  "checkbox": "Top-module__qZlxYG__checkbox",
  "color": "Top-module__qZlxYG__color",
  "colorAttribute": "Top-module__qZlxYG__colorAttribute",
  "colorOption": "Top-module__qZlxYG__colorOption",
  "container": "Top-module__qZlxYG__container",
  "contents": "Top-module__qZlxYG__contents",
  "disabled": "Top-module__qZlxYG__disabled",
  "emiButton": "Top-module__qZlxYG__emiButton",
  "emiTenor": "Top-module__qZlxYG__emiTenor",
  "emiTenors": "Top-module__qZlxYG__emiTenors",
  "gift": "Top-module__qZlxYG__gift",
  "giftPopup": "Top-module__qZlxYG__giftPopup",
  "gifts": "Top-module__qZlxYG__gifts",
  "icon": "Top-module__qZlxYG__icon",
  "image": "Top-module__qZlxYG__image",
  "imageViewer": "Top-module__qZlxYG__imageViewer",
  "info": "Top-module__qZlxYG__info",
  "invalid": "Top-module__qZlxYG__invalid",
  "left": "Top-module__qZlxYG__left",
  "mainImage": "Top-module__qZlxYG__mainImage",
  "name": "Top-module__qZlxYG__name",
  "notify": "Top-module__qZlxYG__notify",
  "option": "Top-module__qZlxYG__option",
  "options": "Top-module__qZlxYG__options",
  "paymentTabs": "Top-module__qZlxYG__paymentTabs",
  "prePrice": "Top-module__qZlxYG__prePrice",
  "price": "Top-module__qZlxYG__price",
  "productName": "Top-module__qZlxYG__productName",
  "rating": "Top-module__qZlxYG__rating",
  "ratingContainer": "Top-module__qZlxYG__ratingContainer",
  "review": "Top-module__qZlxYG__review",
  "right": "Top-module__qZlxYG__right",
  "rightGift": "Top-module__qZlxYG__rightGift",
  "row": "Top-module__qZlxYG__row",
  "shakeAnime": "Top-module__qZlxYG__shakeAnime",
  "subtitle": "Top-module__qZlxYG__subtitle",
  "swiper": "Top-module__qZlxYG__swiper",
  "tag": "Top-module__qZlxYG__tag",
  "text": "Top-module__qZlxYG__text",
  "textOption": "Top-module__qZlxYG__textOption",
  "top": "Top-module__qZlxYG__top",
  "viewImage": "Top-module__qZlxYG__viewImage",
  "warranty": "Top-module__qZlxYG__warranty",
  "warrantyBadge": "Top-module__qZlxYG__warrantyBadge",
  "warrantyCard": "Top-module__qZlxYG__warrantyCard",
  "warrantyContent": "Top-module__qZlxYG__warrantyContent",
  "warrantyDetails": "Top-module__qZlxYG__warrantyDetails",
  "warrantySubtitle": "Top-module__qZlxYG__warrantySubtitle",
  "warrantyTitle": "Top-module__qZlxYG__warrantyTitle",
});
